
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ShopSearch = ({ onSearch }) => {
  const { t } = useTranslation();

  const handleChange = (e) => {
    if (onSearch) onSearch(e.target.value);
  };

  return (
    <div className="sidebar-widget">
      <h4 className="pro-sidebar-title">{t('Search')}</h4>
      <div className="pro-sidebar-search mb-50 mt-25">
        <div className="pro-sidebar-search-form">
          <input
            type="text"
            placeholder={t('Name or SKU...')}
            onChange={handleChange}
          />
          <button type="button">
            <i className="pe-7s-search" />
          </button>
        </div>
      </div>
    </div>
  );
};

ShopSearch.propTypes = {
  onSearch: PropTypes.func,
};

export default ShopSearch;
